import type { FieldMeta } from "vee-validate";

export function displayError(fieldMeta: FieldMeta<unknown>): boolean {
  return fieldMeta.touched && !fieldMeta.valid;
}

export function immediateDisplayError(fieldMeta: FieldMeta<unknown>): boolean {
  return !fieldMeta.valid;
}
